import type { RouteObject } from 'react-router-dom';
import { contestRoutes } from './contest.routes';
import { dashboardRoutes } from './dashboard.routes';
import { fullScreenRoutes } from './fullScreen.routes';
import { guestRoutes } from './guest.routes';
import { mainSectionRoutes } from './mainSection.routes';
import { programRoutes } from './program.routes';
import { operationRoutes } from './operation.routes';
import { userRoutes } from './user.routes';
import { storeRoutes } from './store.routes';
import { paymentsRoutes } from './payments.routes';
import { systemRoutes } from './system.routes';
import { myRoutes } from './my.routes';

export const guestRouteModules: RouteObject[] = [guestRoutes];

export const appRouteModules: RouteObject[] = [
	dashboardRoutes,
	mainSectionRoutes,
	userRoutes,
	contestRoutes,
	programRoutes,
	operationRoutes,
	storeRoutes,
	paymentsRoutes,
	systemRoutes,
	myRoutes
];

export const fullScreenRouteModules: RouteObject[] = fullScreenRoutes;
